import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { TeamMember } from '@interfaces/code-team/team-member';
import { CodeData } from '@interfaces/code-team/code-data';

interface CodeTeamState {
  teamMembers: TeamMember[];
  codes: CodeData[];
}

export const initialValue: CodeTeamState = {
  teamMembers: [],
  codes: [],
};

export const CodeTeamStore = signalStore(
  { providedIn: 'root' },
  withState(initialValue),
  withMethods(({ ...store }) => ({
    updateCodes: (codes: CodeData[]) => {
      patchState(store, { codes });
    },
    updateTeamMembers: (teamMembers: TeamMember[]) => {
      patchState(store, { teamMembers });
    },
  })),
);
